//参数配置

let colors = {
  style_1: [
    ['#1a2fc7', '#3a5bec'],
    ['#e53e7e', '#833acd'],
    ['#74f7a8', '#59bdc7'],
    //['#f5ba47', '#e5493b'],
    ['#d0dc2a', '#bac704'],
    //['#ff63c7', '#ff00a3'],
    ['#79ff62', '#22e600'],
    ['#ff4800', '#ff0000'],
    ['#7fff58', '#31ff00'],
    ['#ecfd91', '#f6ff03'],
    ['#a5f4f8', '#01ffba'],
    ['#a6c7f9', '#0097ff'],
    ['#f9a6ec', '#d800ff'],
    ['#f9a5b9', '#ff0178'],
  ],
  style_2: [
    ['#3e61f1', '#1c32c9'],
    ['#15faa0', '#1cbacc'],
    ['#f5bc46', '#e64a3b'],
    ['#f5ba47', '#e5493b'],
    ['#8fffa0', '#43f45d'],
    ['#958bff', '#5948ff'],
    ['#f19282', '#ef5f47'],
    ['#91ffd2', '#42ffb1'],
    ['#b8aeff', '#8b7aff'],
    ['#fbb852', '#fb9700'],
    ['#f8fb55', '#f0f401'],
    ['#5dd5ec', '#00c9f1'],
  ],
  style_3: ['#f24088', '#f58d3e', '#00dfff', '#1ee68f'],
  style_4: ['#e89842', '#15ec9a'],
  style_5: [
    ['#75fcb4', '#02d765'],
    ['#f6be47', '#e9613d'],
    ['#17ddbd', '#12a1dd']
  ],
  style_6: [
    '#67dfb7', '#edaa45', '#3d8bc1', '#475fe1',
    '#eb664c', '#fb9700', '#f0f401', '#00c9f1'
  ],
  style_7: ['#ffa31d', '#67dfb7'],
  style_8: ['#359de9', '#1edece', '#905afd'],
  style_9: [
    '#b7efff', '#6ac6f5', '#3ea3e0', '#2d74a4',
    '#8b7aff', '#fb9700', '#f0f401', '#00c9f1'
  ],
  style_10: [
    '#62ebce', '#ef6097', '#2aabd7', '#475fe1',
    '#eb664c', '#fb9700', '#f0f401', '#00c9f1'
  ],
  style_11: [
    '#1c4c6a', '#2d74a4', '#3ea3e0', '#6ac6f5',
    '#b7efff', '#fb9700', '#f0f401', '#00c9f1'
  ],
  style_12: ['#5f45ff', '#02cdff', '#0090ff', '#314976'],
  style_13: [
    '#43f45d', '#5948ff', '#ef5f47', '#42ffb1',
    '#8b7aff', '#fb9700', '#f0f401', '#00c9f1'
  ],
  style_14: [['#42f8fe', '#0eb3ff'], ['#0581fa', '#5d37a1'], ['#ffe408', '#a68a25'], ['#fbff96', '#f9ff60']],
};

colors.style_1 = [...colors.style_1, ...colors.style_2];
colors.style_2 = [...colors.style_2, ...colors.style_1];

export const myConfigs = {
  charts: {
    colors: colors,
    "theme-blue": {
      series: {
        color: '#fff',
        color_1: '#22325e',
        backgroundColor: '#061445',
        borderColor: '#5165b7',
      },
      xAxis: {
        color: '#fff',
        color_1: '#344b96',
      },
      yAxis: {
        color: '#fff',
        color_1: '#344b96',
        color_2: '#2d3b6c',
      },
      legend: {
        color: '#fff',
      },
      title: {
        color: '#0becf7',
      },
    },
    "theme-green": {
      series: {
        color: '#3a9675',
        color_1: '#e2e2e2',
        backgroundColor: '#eaf6f2',
        borderColor: '#eaf6f2',
      },
      xAxis: {
        color: '#444',
        color_1: '#e6e6e6',
      },
      yAxis: {
        color: '#888',
        color_1: '#e6e6e6',
        color_2: '#e6e6e6',
      },
      legend: {
        color: '#222',
      },
      title: {
        color: '#a0864a',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/configs.js